import React from "react";
import MfaModalDialog from "../../MfaModalDialog/MfaModalDialog"; // Adjust path if needed
import { PulseButton } from "@pulselabs-ai/shared-fe-ui";
import "./MfaShareAppModal.scss"; // Optional: Create if specific styling is needed

interface MfaShareAppModalProps {
  isOpen: boolean;
  onClose: () => void;
  projectId: string | null; // Pass the project ID for context if needed
}

const MfaShareAppModal: React.FC<MfaShareAppModalProps> = ({
  isOpen,
  onClose,
  projectId,
}) => {
  return (
    <MfaModalDialog isOpen={isOpen} onClose={onClose}>
      <div className="mfa-modal-dialog">
        <div className="mfa-modal-dialog-container">
          <div className="headline-xl">Share app</div>
          <div>
            <div className="headline-xs mfa-bottom-padding">
              Coming soon {projectId}
            </div>

            <div className="body-s mfa-top-padding">coming soon</div>
          </div>
        </div>
        <div className="mfa-modal-dialog-footer">
          <PulseButton
          // disabled={
          //   workspaceName.length === 0 ||
          //   workspaceName.length > 20 ||
          //   isLoading
          // }
          // onClick={handleCreateWorkspace}
          // loading={isLoading}
          >
            Share app
          </PulseButton>
        </div>
      </div>
    </MfaModalDialog>
  );
};

export default MfaShareAppModal;
